var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-header"},[_c('Navigator'),_c('BannerInfoPage',{attrs:{"bannerData":_vm.bannerData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }